import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Smartphone, Gift } from 'lucide-react';
export function FinalClose() {
  return <section className="w-full bg-black py-24 px-4 text-white border-t-4 border-yellow-400" data-id="element-85">
      <div className="max-w-3xl mx-auto text-center" data-id="element-86">
        <span className="bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-87">
          Es ahora o nunca
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-white mt-8 mb-6 leading-tight" data-id="element-88">
          Cada Avería que No Resolvés Vos le Regala 80€ a Otro
        </h2>
        <p className="text-xl text-gray-300 font-medium mb-10" data-id="element-89">
          En 30 minutos podrías estar resolviendo tu primera avería. O podrías
          seguir esperando al electricista y pagando lo que él decida cobrarte.
        </p>

        <motion.a href="#compra" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-black font-black text-xl md:text-3xl py-5 md:py-6 px-8 md:px-16 rounded-lg shadow-[0_6px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[4px] transition-all w-full max-w-2xl uppercase tracking-wide mb-6" data-id="element-90">
          ⚡ QUIERO EMPEZAR AHORA →
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-gray-400 font-medium" data-id="element-91">
          <span className="flex items-center gap-1.5" data-id="element-92">
            <Shield size={18} className="text-gray-400" data-id="element-93" /> Garantía 30 días
          </span>
          <span className="hidden md:inline" data-id="element-94">•</span>
          <span className="flex items-center gap-1.5" data-id="element-95">
            <Smartphone size={18} className="text-gray-400" data-id="element-96" /> Acceso inmediato
          </span>
          <span className="hidden md:inline" data-id="element-97">•</span>
          <span className="flex items-center gap-1.5" data-id="element-98">
            <Gift size={18} className="text-yellow-400" data-id="element-99" /> 3 Bonos gratis
            incluidos hoy
          </span>
        </div>
      </div>
    </section>;
}